<template>
    <section class="sessao-landing-page" id="quem-somos">
        <h2 class="titulo-padrao" data-aos="fade" data-aos-duration="1200">Quem Somos</h2>
        
        <section class="conteudo-sessao-landing-page">
            <img src="@/assets/banner.jpg" alt="fundo" class="foto-sessao" data-aos="fade" data-aos-delay="200" data-aos-duration="1200">
    
            <div class="textos-sessao">
                <h2 class="subtitulo-padrao" data-aos="fade" data-aos-delay="200" data-aos-duration="1200">Cuidado que transforma ambientes</h2>
                <p class="descricao-padrao" data-aos="fade" data-aos-delay="250" data-aos-duration="1200">
                    Somos uma empresa especializada em higienização, dedicada a devolver limpeza, conforto e cuidado aos ambientes.
                    <br>
                    <br>
                    Trabalhamos com atenção em cada detalhe para proporcionar um atendimento de qualidade e resultados que fazem a diferença no dia a dia. Seja em casa, no trabalho ou no seu veículo, cuidamos de cada peça com responsabilidade e dedicação.
                    <br>
                    <br>
                    Nosso compromisso é oferecer um serviço eficiente, com atendimento próximo e foco na satisfação de cada cliente.
                    <br>
                    <br>
                    Mais do que limpar, cuidamos do que faz parte da sua rotina.
                </p>
            </div>
        </section>
        
        <p class="frese-final" data-aos="fade" data-aos-delay="300" data-aos-duration="1200">
            "Prezamos pela satisfação de cada cliente e buscamos oferecer uma experiência de qualidade em todos os nossos atendimentos. Trabalhamos com dedicação, cuidado e atenção aos detalhes para entregar resultados que superem expectativas."
        </p>
    </section>
</template>

<script>
export default{
    name: 'SobreEmpresaLandingPage'
}
</script>

<style scoped>
.sessao-landing-page{
    min-height: 100vh;
    width: 100%;
    padding: 42px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    border-bottom: solid 1px #12121232;
    border-top: solid 1px #12121232;
    border-radius: 10px;
}

.conteudo-sessao-landing-page{
    height: auto;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 32px;
}

.titulo-padrao{
    font-size: 32px;
}

.textos-sessao{
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.subtitulo-padrao{
    font-size: 18px;
    font-weight: 400;
}

.descricao-padrao{
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
}

.foto-sessao{
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 12px;
}

.frese-final{
    max-width: 1200px;
    padding: 46px 32px;
    box-sizing: border-box;
    border-radius: 12px;
    font-size: 14px;
    background-color: var(--cor-tema);
    color: #fdfeff;
    font-weight: 300;
}

@media (min-width: 768px) and (max-width: 1200px){
    .sessao-landing-page{
        padding: 42px 24px;
        min-height: auto;
    }

    .foto-sessao{
        height: 100%;
    }
}

@media (max-width: 600px) {
    .sessao-landing-page{
        padding: 42px 24px;
        min-height: auto;
    }

    .conteudo-sessao-landing-page{
        grid-template-columns: 1fr;
    }

    .titulo-padrao{
        font-size: 22px;
    }

    .subtitulo-padrao{
        font-size: 18px;
    }

    .descricao-padrao{
        font-size: 14px;
    }

    .frese-final{
        padding: 36px 22px
    }
}
</style>